import React from "react";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import Button from "../components/button";
import SectionHead from "../components/section-head";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

const Path = styled((props) => <Link {...props} />)`
  text-decoration: none !important;
  display: flex;
  margin-bottom: 80px;
`;

const SingleLink = ({ title, type, url }) => {
  return (
    <div className="row-container">
      {title && type === "free" ? (
        <SectionHead
          title=""
          link={url
            ?.replace("localhost:8000", "")
            .replace("enkle.re/MEV-DEV", "")
            .replace("https://", "")
            .replace("http://", "")}
          hasLink
          linkLabel={title}
          isCentered
        />
      ) : (
        <Path
          to={url
            ?.replace("localhost:8000", "")
            .replace("enkle.re/MEV-DEV", "")
            .replace("https://", "")
            .replace("http://", "")}
        >
          <Button variant="primary" hasIcon={true}>
            {title}
            <FontAwesomeIcon
              icon={faArrowRight}
              style={{ paddingLeft: "1rem" }}
            />
          </Button>
        </Path>
      )}
    </div>
  );
};

SingleLink.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  url: PropTypes.string,
};

SingleLink.defaultProps = {
  title: undefined,
  type: undefined,
  url: undefined,
};

export default SingleLink;
